import React from "react";

function RightPixelButton({color}: {color: string}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="30"
      shapeRendering="crispEdges"
    >
      <path fill={color} d="M0 0H1V1H0z"></path>
      <path fill={color} d="M1 0H2V1H1z"></path>
      <path fill={color} d="M2 0H3V1H2z"></path>
      <path fill={color} d="M3 0H4V1H3z"></path>
      <path fill={color} d="M0 1H1V2H0z"></path>
      <path fill={color} d="M1 1H2V2H1z"></path>
      <path fill={color} d="M2 1H3V2H2z"></path>
      <path fill={color} d="M3 1H4V2H3z"></path>
      <path fill={color} d="M0 2H1V3H0z"></path>
      <path fill={color} d="M1 2H2V3H1z"></path>
      <path fill={color} d="M2 2H3V3H2z"></path>
      <path fill={color} d="M3 2H4V3H3z"></path>
      <path fill={color} d="M0 3H1V4H0z"></path>
      <path fill={color} d="M1 3H2V4H1z"></path>
      <path fill={color} d="M2 3H3V4H2z"></path>
      <path fill={color} d="M3 3H4V4H3z"></path>
      <path fill={color} d="M4 3H5V4H4z"></path>
      <path fill={color} d="M5 3H6V4H5z"></path>
      <path fill={color} d="M6 3H7V4H6z"></path>
      <path fill={color} d="M7 3H8V4H7z"></path>
      <path fill={color} d="M0 4H1V5H0z"></path>
      <path fill={color} d="M1 4H2V5H1z"></path>
      <path fill={color} d="M2 4H3V5H2z"></path>
      <path fill={color} d="M3 4H4V5H3z"></path>
      <path fill={color} d="M4 4H5V5H4z"></path>
      <path fill={color} d="M5 4H6V5H5z"></path>
      <path fill={color} d="M6 4H7V5H6z"></path>
      <path fill={color} d="M7 4H8V5H7z"></path>
      <path fill={color} d="M0 5H1V6H0z"></path>
      <path fill={color} d="M1 5H2V6H1z"></path>
      <path fill={color} d="M2 5H3V6H2z"></path>
      <path fill={color} d="M3 5H4V6H3z"></path>
      <path fill={color} d="M4 5H5V6H4z"></path>
      <path fill={color} d="M5 5H6V6H5z"></path>
      <path fill={color} d="M6 5H7V6H6z"></path>
      <path fill={color} d="M7 5H8V6H7z"></path>
      <path fill={color} d="M0 6H1V7H0z"></path>
      <path fill={color} d="M1 6H2V7H1z"></path>
      <path fill={color} d="M2 6H3V7H2z"></path>
      <path fill={color} d="M3 6H4V7H3z"></path>
      <path fill={color} d="M4 6H5V7H4z"></path>
      <path fill={color} d="M5 6H6V7H5z"></path>
      <path fill={color} d="M6 6H7V7H6z"></path>
      <path fill={color} d="M7 6H8V7H7z"></path>
      <path fill={color} d="M0 7H1V8H0z"></path>
      <path fill={color} d="M1 7H2V8H1z"></path>
      <path fill={color} d="M2 7H3V8H2z"></path>
      <path fill={color} d="M3 7H4V8H3z"></path>
      <path fill={color} d="M4 7H5V8H4z"></path>
      <path fill={color} d="M5 7H6V8H5z"></path>
      <path fill={color} d="M6 7H7V8H6z"></path>
      <path fill={color} d="M7 7H8V8H7z"></path>
      <path fill={color} d="M8 7H9V8H8z"></path>
      <path fill={color} d="M9 7H10V8H9z"></path>
      <path fill={color} d="M10 7H11V8H10z"></path>
      <path fill={color} d="M11 7H12V8H11z"></path>
      <path fill={color} d="M0 8H1V9H0z"></path>
      <path fill={color} d="M1 8H2V9H1z"></path>
      <path fill={color} d="M2 8H3V9H2z"></path>
      <path fill={color} d="M3 8H4V9H3z"></path>
      <path fill={color} d="M4 8H5V9H4z"></path>
      <path fill={color} d="M5 8H6V9H5z"></path>
      <path fill={color} d="M6 8H7V9H6z"></path>
      <path fill={color} d="M7 8H8V9H7z"></path>
      <path fill={color} d="M8 8H9V9H8z"></path>
      <path fill={color} d="M9 8H10V9H9z"></path>
      <path fill={color} d="M10 8H11V9H10z"></path>
      <path fill={color} d="M11 8H12V9H11z"></path>
      <path fill={color} d="M0 9H1V10H0z"></path>
      <path fill={color} d="M1 9H2V10H1z"></path>
      <path fill={color} d="M2 9H3V10H2z"></path>
      <path fill={color} d="M3 9H4V10H3z"></path>
      <path fill={color} d="M4 9H5V10H4z"></path>
      <path fill={color} d="M5 9H6V10H5z"></path>
      <path fill={color} d="M6 9H7V10H6z"></path>
      <path fill={color} d="M7 9H8V10H7z"></path>
      <path fill={color} d="M8 9H9V10H8z"></path>
      <path fill={color} d="M9 9H10V10H9z"></path>
      <path fill={color} d="M10 9H11V10H10z"></path>
      <path fill={color} d="M11 9H12V10H11z"></path>
      <path fill={color} d="M0 10H1V11H0z"></path>
      <path fill={color} d="M1 10H2V11H1z"></path>
      <path fill={color} d="M2 10H3V11H2z"></path>
      <path fill={color} d="M3 10H4V11H3z"></path>
      <path fill={color} d="M4 10H5V11H4z"></path>
      <path fill={color} d="M5 10H6V11H5z"></path>
      <path fill={color} d="M6 10H7V11H6z"></path>
      <path fill={color} d="M7 10H8V11H7z"></path>
      <path fill={color} d="M8 10H9V11H8z"></path>
      <path fill={color} d="M9 10H10V11H9z"></path>
      <path fill={color} d="M10 10H11V11H10z"></path>
      <path fill={color} d="M11 10H12V11H11z"></path>
      <path fill={color} d="M0 11H1V12H0z"></path>
      <path fill={color} d="M1 11H2V12H1z"></path>
      <path fill={color} d="M2 11H3V12H2z"></path>
      <path fill={color} d="M3 11H4V12H3z"></path>
      <path fill={color} d="M4 11H5V12H4z"></path>
      <path fill={color} d="M5 11H6V12H5z"></path>
      <path fill={color} d="M6 11H7V12H6z"></path>
      <path fill={color} d="M7 11H8V12H7z"></path>
      <path fill={color} d="M8 11H9V12H8z"></path>
      <path fill={color} d="M9 11H10V12H9z"></path>
      <path fill={color} d="M10 11H11V12H10z"></path>
      <path fill={color} d="M11 11H12V12H11z"></path>
      <path fill={color} d="M0 12H1V13H0z"></path>
      <path fill={color} d="M1 12H2V13H1z"></path>
      <path fill={color} d="M2 12H3V13H2z"></path>
      <path fill={color} d="M3 12H4V13H3z"></path>
      <path fill={color} d="M4 12H5V13H4z"></path>
      <path fill={color} d="M5 12H6V13H5z"></path>
      <path fill={color} d="M6 12H7V13H6z"></path>
      <path fill={color} d="M7 12H8V13H7z"></path>
      <path fill={color} d="M8 12H9V13H8z"></path>
      <path fill={color} d="M9 12H10V13H9z"></path>
      <path fill={color} d="M10 12H11V13H10z"></path>
      <path fill={color} d="M11 12H12V13H11z"></path>
      <path fill={color} d="M0 13H1V14H0z"></path>
      <path fill={color} d="M1 13H2V14H1z"></path>
      <path fill={color} d="M2 13H3V14H2z"></path>
      <path fill={color} d="M3 13H4V14H3z"></path>
      <path fill={color} d="M4 13H5V14H4z"></path>
      <path fill={color} d="M5 13H6V14H5z"></path>
      <path fill={color} d="M6 13H7V14H6z"></path>
      <path fill={color} d="M7 13H8V14H7z"></path>
      <path fill={color} d="M8 13H9V14H8z"></path>
      <path fill={color} d="M9 13H10V14H9z"></path>
      <path fill={color} d="M10 13H11V14H10z"></path>
      <path fill={color} d="M11 13H12V14H11z"></path>
      <path fill={color} d="M0 14H1V15H0z"></path>
      <path fill={color} d="M1 14H2V15H1z"></path>
      <path fill={color} d="M2 14H3V15H2z"></path>
      <path fill={color} d="M3 14H4V15H3z"></path>
      <path fill={color} d="M4 14H5V15H4z"></path>
      <path fill={color} d="M5 14H6V15H5z"></path>
      <path fill={color} d="M6 14H7V15H6z"></path>
      <path fill={color} d="M7 14H8V15H7z"></path>
      <path fill={color} d="M8 14H9V15H8z"></path>
      <path fill={color} d="M9 14H10V15H9z"></path>
      <path fill={color} d="M10 14H11V15H10z"></path>
      <path fill={color} d="M11 14H12V15H11z"></path>
      <path fill={color} d="M0 15H1V16H0z"></path>
      <path fill={color} d="M1 15H2V16H1z"></path>
      <path fill={color} d="M2 15H3V16H2z"></path>
      <path fill={color} d="M3 15H4V16H3z"></path>
      <path fill={color} d="M4 15H5V16H4z"></path>
      <path fill={color} d="M5 15H6V16H5z"></path>
      <path fill={color} d="M6 15H7V16H6z"></path>
      <path fill={color} d="M7 15H8V16H7z"></path>
      <path fill={color} d="M8 15H9V16H8z"></path>
      <path fill={color} d="M9 15H10V16H9z"></path>
      <path fill={color} d="M10 15H11V16H10z"></path>
      <path fill={color} d="M11 15H12V16H11z"></path>
      <path fill={color} d="M0 16H1V17H0z"></path>
      <path fill={color} d="M1 16H2V17H1z"></path>
      <path fill={color} d="M2 16H3V17H2z"></path>
      <path fill={color} d="M3 16H4V17H3z"></path>
      <path fill={color} d="M4 16H5V17H4z"></path>
      <path fill={color} d="M5 16H6V17H5z"></path>
      <path fill={color} d="M6 16H7V17H6z"></path>
      <path fill={color} d="M7 16H8V17H7z"></path>
      <path fill={color} d="M8 16H9V17H8z"></path>
      <path fill={color} d="M9 16H10V17H9z"></path>
      <path fill={color} d="M10 16H11V17H10z"></path>
      <path fill={color} d="M11 16H12V17H11z"></path>
      <path fill={color} d="M0 17H1V18H0z"></path>
      <path fill={color} d="M1 17H2V18H1z"></path>
      <path fill={color} d="M2 17H3V18H2z"></path>
      <path fill={color} d="M3 17H4V18H3z"></path>
      <path fill={color} d="M4 17H5V18H4z"></path>
      <path fill={color} d="M5 17H6V18H5z"></path>
      <path fill={color} d="M6 17H7V18H6z"></path>
      <path fill={color} d="M7 17H8V18H7z"></path>
      <path fill={color} d="M8 17H9V18H8z"></path>
      <path fill={color} d="M9 17H10V18H9z"></path>
      <path fill={color} d="M10 17H11V18H10z"></path>
      <path fill={color} d="M11 17H12V18H11z"></path>
      <path fill={color} d="M0 18H1V19H0z"></path>
      <path fill={color} d="M1 18H2V19H1z"></path>
      <path fill={color} d="M2 18H3V19H2z"></path>
      <path fill={color} d="M3 18H4V19H3z"></path>
      <path fill={color} d="M4 18H5V19H4z"></path>
      <path fill={color} d="M5 18H6V19H5z"></path>
      <path fill={color} d="M6 18H7V19H6z"></path>
      <path fill={color} d="M7 18H8V19H7z"></path>
      <path fill={color} d="M8 18H9V19H8z"></path>
      <path fill={color} d="M9 18H10V19H9z"></path>
      <path fill={color} d="M10 18H11V19H10z"></path>
      <path fill={color} d="M11 18H12V19H11z"></path>
      <path fill={color} d="M0 19H1V20H0z"></path>
      <path fill={color} d="M1 19H2V20H1z"></path>
      <path fill={color} d="M2 19H3V20H2z"></path>
      <path fill={color} d="M3 19H4V20H3z"></path>
      <path fill={color} d="M4 19H5V20H4z"></path>
      <path fill={color} d="M5 19H6V20H5z"></path>
      <path fill={color} d="M6 19H7V20H6z"></path>
      <path fill={color} d="M7 19H8V20H7z"></path>
      <path fill={color} d="M8 19H9V20H8z"></path>
      <path fill={color} d="M9 19H10V20H9z"></path>
      <path fill={color} d="M10 19H11V20H10z"></path>
      <path fill={color} d="M11 19H12V20H11z"></path>
      <path fill={color} d="M0 20H1V21H0z"></path>
      <path fill={color} d="M1 20H2V21H1z"></path>
      <path fill={color} d="M2 20H3V21H2z"></path>
      <path fill={color} d="M3 20H4V21H3z"></path>
      <path fill={color} d="M4 20H5V21H4z"></path>
      <path fill={color} d="M5 20H6V21H5z"></path>
      <path fill={color} d="M6 20H7V21H6z"></path>
      <path fill={color} d="M7 20H8V21H7z"></path>
      <path fill={color} d="M8 20H9V21H8z"></path>
      <path fill={color} d="M9 20H10V21H9z"></path>
      <path fill={color} d="M10 20H11V21H10z"></path>
      <path fill={color} d="M11 20H12V21H11z"></path>
      <path fill={color} d="M0 21H1V22H0z"></path>
      <path fill={color} d="M1 21H2V22H1z"></path>
      <path fill={color} d="M2 21H3V22H2z"></path>
      <path fill={color} d="M3 21H4V22H3z"></path>
      <path fill={color} d="M4 21H5V22H4z"></path>
      <path fill={color} d="M5 21H6V22H5z"></path>
      <path fill={color} d="M6 21H7V22H6z"></path>
      <path fill={color} d="M7 21H8V22H7z"></path>
      <path fill={color} d="M8 21H9V22H8z"></path>
      <path fill={color} d="M9 21H10V22H9z"></path>
      <path fill={color} d="M10 21H11V22H10z"></path>
      <path fill={color} d="M11 21H12V22H11z"></path>
      <path fill={color} d="M0 22H1V23H0z"></path>
      <path fill={color} d="M1 22H2V23H1z"></path>
      <path fill={color} d="M2 22H3V23H2z"></path>
      <path fill={color} d="M3 22H4V23H3z"></path>
      <path fill={color} d="M4 22H5V23H4z"></path>
      <path fill={color} d="M5 22H6V23H5z"></path>
      <path fill={color} d="M6 22H7V23H6z"></path>
      <path fill={color} d="M7 22H8V23H7z"></path>
      <path fill={color} d="M8 22H9V23H8z"></path>
      <path fill={color} d="M9 22H10V23H9z"></path>
      <path fill={color} d="M10 22H11V23H10z"></path>
      <path fill={color} d="M11 22H12V23H11z"></path>
      <path fill={color} d="M0 23H1V24H0z"></path>
      <path fill={color} d="M1 23H2V24H1z"></path>
      <path fill={color} d="M2 23H3V24H2z"></path>
      <path fill={color} d="M3 23H4V24H3z"></path>
      <path fill={color} d="M4 23H5V24H4z"></path>
      <path fill={color} d="M5 23H6V24H5z"></path>
      <path fill={color} d="M6 23H7V24H6z"></path>
      <path fill={color} d="M7 23H8V24H7z"></path>
      <path fill={color} d="M0 24H1V25H0z"></path>
      <path fill={color} d="M1 24H2V25H1z"></path>
      <path fill={color} d="M2 24H3V25H2z"></path>
      <path fill={color} d="M3 24H4V25H3z"></path>
      <path fill={color} d="M4 24H5V25H4z"></path>
      <path fill={color} d="M5 24H6V25H5z"></path>
      <path fill={color} d="M6 24H7V25H6z"></path>
      <path fill={color} d="M7 24H8V25H7z"></path>
      <path fill={color} d="M0 25H1V26H0z"></path>
      <path fill={color} d="M1 25H2V26H1z"></path>
      <path fill={color} d="M2 25H3V26H2z"></path>
      <path fill={color} d="M3 25H4V26H3z"></path>
      <path fill={color} d="M4 25H5V26H4z"></path>
      <path fill={color} d="M5 25H6V26H5z"></path>
      <path fill={color} d="M6 25H7V26H6z"></path>
      <path fill={color} d="M7 25H8V26H7z"></path>
      <path fill={color} d="M0 26H1V27H0z"></path>
      <path fill={color} d="M1 26H2V27H1z"></path>
      <path fill={color} d="M2 26H3V27H2z"></path>
      <path fill={color} d="M3 26H4V27H3z"></path>
      <path fill={color} d="M4 26H5V27H4z"></path>
      <path fill={color} d="M5 26H6V27H5z"></path>
      <path fill={color} d="M6 26H7V27H6z"></path>
      <path fill={color} d="M7 26H8V27H7z"></path>
      <path fill={color} d="M0 27H1V28H0z"></path>
      <path fill={color} d="M1 27H2V28H1z"></path>
      <path fill={color} d="M2 27H3V28H2z"></path>
      <path fill={color} d="M3 27H4V28H3z"></path>
      <path fill={color} d="M0 28H1V29H0z"></path>
      <path fill={color} d="M1 28H2V29H1z"></path>
      <path fill={color} d="M2 28H3V29H2z"></path>
      <path fill={color} d="M3 28H4V29H3z"></path>
      <path fill={color} d="M0 29H1V30H0z"></path>
      <path fill={color} d="M1 29H2V30H1z"></path>
      <path fill={color} d="M2 29H3V30H2z"></path>
      <path fill={color} d="M3 29H4V30H3z"></path>
    </svg>
  );
}

export default RightPixelButton;
